import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TerminalDetailResponse } from '@/repositories/generated';

const response: TerminalDetailResponse = {
  id: '0000000002003',
  name: 'テスト端末',
  externalTerminalId: 'terminal10021',
  status: 'AVAILABLE',
  defaultTerminal: true,
  isLogin: true,
  terminalDetailBasicInfo: {
    terminalType: 'PAPER_QR',
    terminalPassword: '1234',
    osType: 'iOS',
    osVersion: '11.0',
    companyResponse: {
      id: '010',
      name: '株式会社インフキュリオン',
    },
    startDate: '2023-01-01',
    endDate: '2033-12-31',
    shopResponse: {
      id: '001',
      name: 'テスト店舗',
    },
    createdAt: '2021-01-01 00:00:00',
    updatedAt: '2021-01-01 00:00:00',
  },
  terminalDetailQrInfo: {
    corporationId: '11111111',
    brandId: '2222',
    contractStoreId: '3333',
    terminalStickerId: '444444',
  },
  remarks: '備考',
};

export const terminalDetail = http.get(
  createMockEndpoint('/terminal/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
